import cx from 'clsx';
import type { ImageProps } from 'next/legacy/image';

import type { ProductStatus } from '~/api/model';
import { ResizeNextImage } from '~/app/common/components/ResizeNextImage';

import { ProductDisabledImageOverlay } from '~/app/common/components/Product/ProductDisabledImageOverlay';

export type StatusType = ProductStatus;

type Props = {
  src: string;
  alt?: string;
  type?: 'list' | 'grid';
  isOutOfStock?: boolean;
  rightBottom?: React.ReactNode;
  status?: StatusType;
  inverse?: boolean;
  className?: string;
  imageWrapperClassName?: string;
  leftTop?: React.ReactNode;
} & ImageProps;

export function ProductImage({
  src,
  alt,
  isOutOfStock,
  rightBottom,
  type = 'grid',
  status,
  inverse,
  className,
  imageWrapperClassName,
  leftTop,
  ...props
}: Props) {
  return (
    <div
      className={cx([
        'relative overflow-hidden rounded-16 border border-02 bg-screen-01 mb-8',
        inverse && 'after:bg-gray-000 [&>div]:z-10',
        className,
      ])}
    >
      <div className={cx('aspect-w-1 aspect-h-1', imageWrapperClassName)}>
        <div>
          <ResizeNextImage {...props} src={src} alt={alt} objectFit="contain" />
        </div>
      </div>
      <ProductDisabledImageOverlay
        type={type}
        status={status}
        isOutOfStock={isOutOfStock}
      />
      {leftTop && <div className="absolute left-0 top-0">{leftTop}</div>}
      {rightBottom && (
        <div className="absolute bottom-0 right-0">{rightBottom}</div>
      )}
    </div>
  );
}
